import { NotifyHelper } from "../../../helpers/toast";
import { eKeHoachMonGhepCapActionsObj } from "../../action-types/ke-hoach/IKeHoachMonGhepCapActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const keHoachMonGhepCapActions = {
    ...generateActions(eKeHoachMonGhepCapActionsObj, "GHEP_CAP"),
    ...generateActionForKey(eKeHoachMonGhepCapActionsObj, "GHEP_CAP", "SAVE_SUCCESS", () => NotifyHelper.Success("Thành công")),
    ...generateActionForKey(eKeHoachMonGhepCapActionsObj, "GHEP_CAP", "DELETE_SUCCESS", () => NotifyHelper.Success("Thành công")),
    ...generateActionForKey(eKeHoachMonGhepCapActionsObj, "GHEP_CAP", "SAVE_ERROR", (m) => NotifyHelper.Error(m)),
    ...generateActionForKey(eKeHoachMonGhepCapActionsObj, "GHEP_CAP", "DELETE_ERROR", (m) => NotifyHelper.Error(m)),
};
